// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"bb66e072","536":"1a9cb0bd","816":"00a2094d"}[chunkId] + ".chunk.css";
};